import { useEffect, useState } from "react"
import type { PostHog } from "posthog-js"
import { PostHogRouteTracker } from "@/components/analytics/PostHogRouteTracker"

export function PostHogRuntime() {
  const [client, setClient] = useState<PostHog | null>(null)

  useEffect(() => {
    let cancelled = false
    let timeoutHandle: number | null = null
    let idleHandle: number | null = null

    const loadPostHog = () => {
      void import("@/lib/posthog/init").then(({ initPostHog }) => {
        if (!cancelled) {
          setClient(initPostHog())
        }
      })
    }

    if (typeof window.requestIdleCallback === "function") {
      idleHandle = window.requestIdleCallback(loadPostHog, { timeout: 3000 })
    } else {
      timeoutHandle = window.setTimeout(loadPostHog, 1500)
    }

    return () => {
      cancelled = true
      if (idleHandle !== null) {
        window.cancelIdleCallback(idleHandle)
      }
      if (timeoutHandle !== null) {
        window.clearTimeout(timeoutHandle)
      }
    }
  }, [])

  return client ? <PostHogRouteTracker client={client} /> : null
}
